import * as Recharts from 'recharts';

class Legend extends Recharts.Legend {
  static type = Recharts.Legend.type;
  static displayName = Recharts.Legend.displayName;
  static defaultProps = {
    ...Recharts.Legend.defaultProps,
    layout: 'vertical',
    verticalAlign: 'top',
    align: 'right',
    wrapperStyle: { top: 0, right: 0, bottom: '12px', overflow: 'auto' },
  };
}

export default Legend;
